import React from "react";
import Slider from "react-slick";
import { Box, Typography, Rating } from "@mui/material";
import { Review } from "../../../api/reviews/dto";
import "./ReviewBlock.css";
import theme from "../../../assets/theme/Theme";
import useMediaQuery from "@mui/material/useMediaQuery";
import { ThemeProvider, useTheme } from "@mui/material/styles";

interface ReviewsViewProps {
    reviews: Review[];
    loading: boolean;
    error: string | null;
}

export const ReviewsBlockView: React.FC<ReviewsViewProps> = ({
                                                                 reviews,
                                                                 loading,
                                                                 error,
                                                             }) => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    const theme = useTheme();
    const isXsScreen = useMediaQuery(theme.breakpoints.only("xs"));

    const TitleText = {
        color: "#288e81",
        fontSize: isXsScreen ? 22 : 38,
        fontFamily: "Austin, sans-serif",
        textTransform: "uppercase",
        // maxWidth: isXsScreen ? 240 : 500,
        textAlign: isXsScreen ? "center" : "left",
        // marginBottom: "25px",
    };

    if (loading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
                <Typography>Загрузка...</Typography>
            </Box>
        );
    }

    if (error) {
        return (
            <Typography textAlign="center" color="error" marginTop={4}>
                {error}
            </Typography>
        );
    }

    if (reviews.length === 0) {
        return (
            <Typography textAlign="center" marginTop={4}>

            </Typography>
        );
    }

    return (
        <Box sx={{ padding: "40px 0px" }}>
            <Typography sx={TitleText} marginBottom={4} >
                Отзывы наших клиентов
            </Typography>
            <Slider {...settings}>
                {reviews.map((review) => (
                    <div className="review-card" key={review.id}>
                        <div className="review-card-item">
                            <div className="review-card-top">
                                <Typography
                                    variant="h6"
                                    style={{
                                        fontWeight: "bold",
                                        color: "#088E81",
                                        textTransform: "uppercase",
                                    }}
                                >
                                    {review.name}
                                </Typography>
                                <Typography
                                    variant="body2"
                                    color="textSecondary"
                                    style={{ marginBottom: "8px" }}
                                >
                                    {new Date(review.date).toLocaleDateString()}
                                </Typography>
                                <Rating value={review.rating} readOnly precision={0.5} />
                            </div>
                            <div className="review-card-bottom">
                                <Typography
                                    variant="body1"
                                    style={{
                                        marginTop: "15px",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        display: "-webkit-box",
                                        WebkitLineClamp: 5,
                                        WebkitBoxOrient: "vertical",
                                    }}
                                >
                                    {review.content}
                                </Typography>
                            </div>
                        </div>
                    </div>
                ))}
            </Slider>
        </Box>
    );
};
